import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// MEMO: ScrollRestoration は他の箇所でも使用する場合ラップコンポーネントを作成すること
import { ScrollRestoration } from 'react-router-dom';
import { CustomOutlet } from '@/components/functional/Link/CustomOutlet';
import App from '@/container/App';
import Notification from '@/container/Notification';
/**
 * ページ全体のレイアウト
 * @description ルーティングのルートファイルにのみ設定する
 * @returns
 */
export const RootLayout = () => (_jsxs(App, { children: [_jsx(Notification, {}), _jsx(ScrollRestoration, {}), _jsx(CustomOutlet, {})] }));
